<template>
  <Form
    :action-type="actionType"
    :subtitle="userSubtitle"
    :disabled="wasDisabled"
    :fallback-link="fallbackLink"
    :form-body="form"
    :show-preloader="isLoadingNow"
    @on-submit="submit"
    @on-edit="setEditMode(true)"
    @on-cancel="setEditMode(false)"
  >
    <template slot="fields">
      <div class="row">
        <div class="col-lg-12">
          <div v-if="form.user.login" class="col-lg-12 form-group">
            <span>Присвоенный логин: <b>{{ form.user.login }}</b></span>
          </div>
          <div v-if="false" class="col-lg-12 form-group">
            <span>
              Календарь смен:
              <router-link
                v-if="form.user.calendar_id"
                :to="calendarLink"
                target="_blank"
              >
                <b>назначен</b>
              </router-link>
              <b v-else>отсутствует</b>
            </span>
          </div>
          <div
            v-for="(value, key, index) in formsFields.user.labels"
            :key="index"
            v-if="!hiddenFields.includes(key)"
            class="col-lg-6 form-group"
          >
            <fieldset>
              <label>
                {{ value }}
                <span
                  v-if="isRequiredField(validationSchemas.user[key]) && checkVipRole()"
                  class="field__label_required"
                  >*</span
                >
              </label>
              <input
                class="form-control"
                :name="key"
                :maxlength="formsFields.user.maxLength[key]"
                placeholder="Отсутствует"
                :disabled="inputsWereDisabled"
                v-model.trim="form.user[key]"
              />
            </fieldset>
          </div>
          <div v-if="selectedRole === 'швея'" class="col-lg-6 form-group">
            <label>Рабочее место</label>
            <input
              :disabled="inputsWereDisabled"
              class="form-control"
              placeholder="Отсутствует"
              v-model="form.user.workplace"
            />
          </div>
          <div v-if="checkVipRole(selectedRole)" class="col-lg-6 form-group">
            <div class="form-group__label_password">
              <label>
                Пароль
              </label>
              <div v-if="passwordCheckboxIsVisible">
                <input v-model="saveOldPassword" type="checkbox" />
                <label>Сохранить старый пароль</label>
              </div>
            </div>
            <input
              :placeholder="passwordStatus"
              :disabled="passwordInputWasDisabled"
              class="form-control"
              v-model="form.user.password"
            />
          </div>
          <div v-if="!isPersonalInfoPage" class="col-lg-6">
            <div class="form__select_role">
              <label>Роль</label>
              <Select
                :default-key="roleDefaultKey"
                @init="initRoleId"
                @input="setRoleId"
                :options="roles"
                :disabled="inputsWereDisabled"
              />
            </div>
          </div>
        </div>
      </div>
      <Sublist subtitle="Паспорт">
        <template slot="fields">
          <div class="row">
            <div class="col-lg-12">
              <div
                v-for="(value, key, index) in formsFields.passport.labels"
                :key="index"
                class="col-lg-6 form-group"
              >
                <fieldset>
                  <label>
                    {{ value }}
                    <span
                      v-if="isRequiredField(validationSchemas.passport[key]) && checkVipRole()"
                      class="field__label_required"
                      >*</span
                    >
                  </label>
                  <input
                    class="form-control"
                    placeholder="Отсутствует"
                    :name="key"
                    :maxlength="formsFields.passport.maxLength[key]"
                    :disabled="inputsWereDisabled"
                    :type="formsFields.passport.inputTypes[key]"
                    v-model.trim="form.passport[key]"
                  />
                </fieldset>
              </div>
            </div>
          </div>
        </template>
      </Sublist>
      <div class="col-lg-6">
        <label class="control-label">
          Изображение
          <label v-if="actionType !== 'read'" class="field__label_required">
            *
          </label>
        </label>
        <ImageInput
          :preview-image="previewImage"
          :only-preview-image="actionType === 'read'"
          @on-select-file="setImage"
          @on-delete="deleteImage"
        />
      </div>
    </template>
  </Form>
</template>

<script>
import { validationMixin } from "vuelidate";
import validationSchemas from "@/user/validation-schemas";
import { userService } from "@/user/api-services";

import Sublist from "@/_shared/features/form/Sublist";
import ImageInput from "@/_shared/features/form/ImageInput";
import Form from "@/_shared/widgets/Form";
import Select from "@/_shared/components/ui/Select";

import { formsFields } from "@/user/constants";
import { roles } from "@/_shared/constants";
import { objectHelper } from "@/_shared/utils";
import {
  useForm,
  useNotification,
  useRoleIdentifier,
  useImageField,
  useTokenPayload,
} from "@/_shared/mixins";
const { createFromKeys } = objectHelper;
export default {
  mixins: [
    validationMixin,
    useForm,
    useNotification,
    useRoleIdentifier,
    useImageField,
    useTokenPayload,
  ],
  components: {
    Sublist,
    ImageInput,
    Form,
    Select,
  },
  data() {
    return {
      saveOldPassword: false,
      formsFields,
      validationSchemas,
      imageSubfield: "user",
      fallbackLink: "/users",
      entityName: {
        readonly: "Пользователь",
        modify: "пользователя",
      },
      form: {
        user: createFromKeys(formsFields.user.labels),
        passport: createFromKeys(formsFields.passport.labels),
      },
      roles,
      hiddenFields: ["password", "role_id", "workplace"],
      passportDataIsVisible: false,
    };
  },
  validations() {
    return {
      form: {
        user: validationSchemas.user,
        passport: validationSchemas.passport,
      },
    };
  },
  async created() {
    if (this.isPersonalInfoPage && !this.checkVipRole()) {
      const text = 'Пользователь с вашей ролью может '
        + 'отредактировать лишь своё фото';
      this.showWarningNotification(text);
    }
    const addingFields = {
      image: {
        name: null,
        content: null,
      },
      user: createFromKeys(this.formsFields.user.labels),
      passport: createFromKeys(this.formsFields.passport.labels),
    };
    await this.setFormFields(addingFields, userService.get).then(() => {
      this.redirectIfNotVip();
      this.form.image_url = this.form.user.image_url;
      if (this.form.user.has_password_hash) {
        this.saveOldPassword = true;
      }
      this.checkPreviewImageExistence();
    });
  },
  computed: {
    calendarLink() {
      const id = this.form.user.calendar_id;
      const link = `/shifts_calendar/${id}`;
      return link;
    },
    userSubtitle() {
      return this.isPersonalInfoPage ? 'Ваш профиль' : this.subtitle;
    },
    inputsWereDisabled() {
      return !!(this.actionType === 'read' || !this.checkVipRole());
    },
    isPersonalInfoPage() {
      return this.$route.path === '/personal_info';
    },
    actionType() {
      const possibleTypes = {
        '/personal_info': 'edit',
        '/users/new': 'add',
      };
      const type = possibleTypes[this.$route.path];
      if (!type) {
        return this.isEditMode ? "edit" : "read";
      }
      return type;
    },
    passwordInputWasDisabled() {
      return !!(this.actionType === 'read' || this.passwordCheckboxIsVisible
        && this.saveOldPassword);
    },
    passwordCheckboxIsVisible() {
      return !!(this.form.user.has_password_hash &&
        this.actionType !== 'read');
    },
    roleDefaultKey() {
      if (this.actionType !== "add") {
        return this.form.user.role_id;
      }
      return null;
    },
    selectedRole() {
      return this.roles[this.form.user.role_id];
    },
    passwordStatus() {
      const { has_password_hash } = this.form.user;
      return has_password_hash ? "Был установлен" : "Отсутствует";
    },
  },
  methods: {
    getSlug() {
      const { fullPath } = this.$router.currentRoute;
      const slug = fullPath.split("/").pop();
      if (slug === 'personal_info') {
        return this.idFromToken;
      }
      return slug;
    },
    async submit() {
      const callback = async () => {
        return await this.encodeImage(true, this.form.user)
          .then(async () => {
            const params = {
              saveOldPassword: this.saveOldPassword,
            };
            if (this.image.name) {
              this.form.image = this.image;
            }
            return await userService[this.actionType](this.form, params);
          })
          .catch((error) => {
            throw new Error(error.message);
          });
      };
      await this.sendForm(callback);
    },
    initRoleId(value) {
      this.form.user.role_id = value;
    },
    setRoleId(value) {
      this.form.user.password = "";
      this.form.user.workplace = "",
      this.form.user.role_id = value;
    },
  },
};
</script>

<style scoped>
.form__select_role {
  display: flex;
  flex-direction: column;
  margin-bottom: 1em;
}
.form-group__label_password {
  display: inline-flex;
  flex-direction: row;
  column-gap: 1em;
}
.input__action_drop-password {
  text-decoration: underline;
}
.input__action_drop-password:hover,
.input__action_drop-password:focus {
  cursor: pointer;
  opacity: 0.6;
  transition: 0.3s;
}
.form__select_role .custom-select {
  line-height: 33px;
  height: 33px;
}
</style>



// WEBPACK FOOTER //
// src/user/pages/UserPage.vue